export default [
  {
    name: '演示1',
    views: [
      {
        name: '视点01',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 100.56,
          heading: 305.47,
          pitch: 21,
        },
        img: '/img/views/pic001.jpg',
      },
      {
        name: '视点02',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 46.59,
          heading: 2.47,
          pitch: 15,
        },
        img: '/img/views/pic002.jpg',
      },
      {
        name: '视点03',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 77.81,
          heading: 52.47,
          pitch: 16.27,
        },
        img: '/img/views/pic003.jpg',
      },
    ],
  },
  {
    name: '演示2',
    views: [
      {
        name: '视点01',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 100.56,
          heading: 305.47,
          pitch: 21,
        },
        img: '/img/views/pic001.jpg',
      },
      {
        name: '视点03',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 77.81,
          heading: 52.47,
          pitch: 16.27,
        },
        img: '/img/views/pic003.jpg',
      },
      {
        name: '视点02',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 46.59,
          heading: 2.47,
          pitch: 15,
        },
        img: '/img/views/pic002.jpg',
      }
    ],
  },
  {
    name: '演示3',
    views: [
      {
        name: '视点03',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 77.81,
          heading: 52.47,
          pitch: 16.27,
        },
        img: '/img/views/pic003.jpg',
      },
      {
        name: '视点01',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 100.56,
          heading: 305.47,
          pitch: 21,
        },
        img: '/img/views/pic001.jpg',
      },
      {
        name: '视点02',
        delay: 2,
        flyTime: 2,
        explain: '漫游文字说明',
        isShow: true,
        cameraInfo: {
          centerCoord: [116.2925499, 39.8282158],
          coordType: 0,
          coordTypeZ: 0,
          coordZ: -7.41,
          distance: 46.59,
          heading: 2.47,
          pitch: 15,
        },
        img: '/img/views/pic002.jpg',
      }
    ],
  },
]